import { Deserializable } from '../../../models/deserializable';
import { custom, deserialize, object, optional, serializable } from 'serializr';

export class AzureProjectModel implements Deserializable {
  @serializable
  public id: string;
  @serializable
  public name: string;
  @serializable
  public url: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(AzureProjectModel, input));
  }
}

export class AzureIssueTypeDefaultWorkItemTypeModel {
  @serializable
  public id: number;
  @serializable
  public url: string;
  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(
      this,
      deserialize(AzureIssueTypeDefaultWorkItemTypeModel, input),
    );
  }
}

export class AzureIssueModel {
  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public fields: any;

  @serializable
  public id: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(AzureIssueModel, input));
  }
}

export class AzureIssueTypeModel implements Deserializable {
  @serializable
  public name: string;
  @serializable
  public url: string;
  @serializable(optional(object(AzureIssueTypeDefaultWorkItemTypeModel)))
  public defaultWorkItemType: AzureIssueTypeDefaultWorkItemTypeModel;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(AzureIssueTypeModel, input));
  }
}
